import { IBookingCalendarStore } from '../../index'
import { IToggleReservationModalSaving } from '../../../../actions/bookingCalendar/reservationModal/toggleReservationModal'

export default function(
  state: IBookingCalendarStore,
  action: IToggleReservationModalSaving,
): IBookingCalendarStore {
  return {
    ...state,
    reservationModal: {
      ...state.reservationModal,
      isSaving: action.toggle,
    },
  }
}
